import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetVaccinesResult } from './get-vaccines.result';

export async function getVaccines(): Promise<GetVaccinesResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetVaccinesResult[]>(`/firms/vaccine-definitions`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
